// ---------------------------------------------
// HOVER TO ACTIVATE HEADING TEXT
// ---------------------------------------------

// (function () {
// 	let imageBanner = () => {
// 		$(".image-banner__heading").hover(function () {
// 			$(this).addClass("active");
// 			$(this).siblings(".image-banner__heading").removeClass("active");
// 		});
// 	};

// 	document.addEventListener("shopify:section:load", function () {
// 		imageBanner();
// 	});

// 	imageBanner();
// })();


// ---------------------------------------------
// SCROLL TO ACTIVATE HEADING TEXT
// ---------------------------------------------


// (function () {
// 	let imageBanner = () => {
// 		let headings = $(".image-banner__heading");

// 		$(window).on("scroll", function () {
// 			let windowCenter = $(window).scrollTop() + $(window).height() / 2;

// 			headings.each(function () {
// 				let elementTop = $(this).offset().top;
// 				let elementBottom = elementTop + $(this).outerHeight();

// 				if (windowCenter >= elementTop && windowCenter <= elementBottom) {
// 					$(this).addClass("active");
// 					$(this).siblings(".image-banner__heading").removeClass("active");
// 				}
// 			});
// 		});
// 	};

// 	document.addEventListener("shopify:section:load", function () {
// 		imageBanner();
// 	});

// 	imageBanner();
// })();


// ---------------------------------------------
// HOVER & SCROLL TO ACTIVATE HEADING TEXT
// ---------------------------------------------


(function () {
	let imageBanner = (options = { hover: true, scroll: true }) => {
		let headings = $(".image-banner__heading");

		if (options.hover) {
			headings.hover(function () {
				$(this).addClass("active");
				$(this).siblings(".image-banner__heading").removeClass("active");
			});
		}

		if (options.scroll) {
			$(window).on("scroll", function () {
				let windowCenter = $(window).scrollTop() + $(window).height() / 2;

				headings.each(function () {
					let elementTop = $(this).offset().top;
					let elementBottom = elementTop + $(this).outerHeight();

					if (windowCenter >= elementTop && windowCenter <= elementBottom) {
						$(this).addClass("active");
						$(this).siblings(".image-banner__heading").removeClass("active");
					}
				});
			});
		}
	};

	document.addEventListener("shopify:section:load", function () {
		imageBanner();
	});

	imageBanner();
})();